// extracted by mini-css-extract-plugin
export default {"SearchResultCount":"styles_SearchResultCount__+Yib3"};